/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './getRepos.defs.js'
export * as $defs from './getRepos.defs.js'
